import { render } from "./ChooseButtons.vue?vue&type=template&id=3c99d966&scoped=true"
import script from "./ChooseButtons.vue?vue&type=script&lang=js"
export * from "./ChooseButtons.vue?vue&type=script&lang=js"

import "./ChooseButtons.vue?vue&type=style&index=0&id=3c99d966&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c99d966"]])

export default __exports__